<script setup lang="ts">
import {type MenuResponse} from "../../responses/MenuResponse";
import {ref} from "vue";
import {chunk} from 'lodash';
import {label} from "../mixins/translations";

interface Props{
    menu: MenuResponse
    currentRoute: string
}

const props = withDefaults(defineProps<Props>(), {});
const activeMenu = ref(null);
const toggleMenu = (activeId) => {
    if(activeMenu.value !== activeId){
        activeMenu.value = activeId;
    }
}
</script>
<template>
    <div class="relative">
        <!-- Menu bar -->
        <ul class="flex flex-wrap w-full items-center justify-center gap-4 sm:gap-12 text-base z-20 relative">
            <li class="px-4 py-2 cursor-pointer" v-for="parentItem in menu.items" @mouseover="toggleMenu(parentItem.id)" :class="{'border-b-[3px]': props.currentRoute === parentItem.slug}">
                <a :href="parentItem.slug" :target="parentItem.open_in_new_window ? '_blank' : '_self'" class="hover:text-black">{{ parentItem.label }}</a>
            </li>
        </ul>

        <!-- Mega menu dropdown -->
        <div v-for="parentItem in menu.items"
            @mouseleave="toggleMenu(null)" :class="{'hidden': parentItem.id !== activeMenu}"
            class="absolute left-0 w-full z-10 bg-white border-t border-gray-200 shadow-lg"
        >
            <div class="bg-[#F8F7F4] text-black py-12">
                <div class="max-w-7xl relative z-20 mx-auto px-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-10">
                    <!-- Kolom 1 -->
                    <div v-for="chunkedItems in chunk(parentItem.items, 3)" class="space-y-4">
                        <div v-for="item in chunkedItems">
                            <h3 class="font-bold" :class="{'mb-2': item.items_count === 0}">
                                <a v-if="item.slug" :href="item.slug" :target="item.open_in_new_window ? '_blank' : '_self'">
                                    {{ item.label }}
                                </a>
                                <span v-else>
                                    {{ item.label }}
                                </span>
                            </h3>
                            <ul class="space-y-1">
                                <li v-for="subItem in item.items">
                                    <a :href="subItem.slug" :target="subItem.open_in_new_window ? '_blank' : '_self'">
                                        {{ subItem.label }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <!-- Rechterafbeelding -->
                <div class="relative z-10 overflow-hidden mt-12 md:mt-0 md:absolute top-0 right-0 w-full md:w-1/4 h-96 md:h-full">
                    <div class="absolute w-full h-full z-10">
                        <svg class="h-full" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 77.86505 586.5">
                            <path style="fill: #f9f9f9;" d="M0,0v586.5h39c48-166.5,38-188,38-229.5S33,209,12.5,141.5C-3.9,87.5,5.66667,24.6667,12.5,0H0Z"/>
                        </svg>
                    </div>
<!--                    <img src="" alt="Snoezelkamer" class="object-cover w-full h-full" />-->
                </div>
            </div>
        </div>
    </div>
</template>
